<template>
    <div>
        <div v-if="success">
            <div class="row">
                <div class="col-sm-12 text-center">
                    <h2>Eine Anfrage wurde versandt.</h2><small>Wir werden Ihnen so schnell wie möglich eine Antwort auf die hinterlegte E-Mail Adresse zukommen lassen.</small>
                </div>
            </div>
        </div>
        <div v-if="showForm">
            <div class="row">
                <div class="col-sm-12 text-center">
                    <h2>nichts gefunden?</h2><small>Fragen Sie uns, wir finden Ihr Ersatzteil!.</small>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-3">
                    <div :class="formGroupClass('brand')">
                        <div class="form-group">
                            <select class="form-control" name="brand" @change="onChangeBrand" v-model="form.brand">
                                <option :value="0">Marke</option>
                                <option v-for="brand in brands" :data-id="brand.id" :value="brand.name">{{brand.name}}</option>
                            </select>
                            <div class="help-block" v-if="form.errors.has('brand')">
                                <strong>{{ form.errors.get('brand') }}</strong>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-sm-3">
                    <div :class="formGroupClass('car')">
                        <div class="form-group">
                            <select class="form-control" name="car" @change="onChangeCar" v-model="form.car">
                                <option :value="0">Modell</option>
                                <option v-for="car in cars" :data-id="car.id" :value="car.name">{{car.name}}</option>
                            </select>
                            <div class="help-block" v-if="form.errors.has('car')">
                                <strong>{{ form.errors.get('car') }}</strong>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-sm-3">
                    <div :class="formGroupClass('year')">
                        <div class="form-group">
                            <select class="form-control" name="year" @change="onChangeYear" v-model="form.year">
                                <option :value="0">Baujahr</option>
                                <option v-for="year in years" :data-id="year.id" :value="year.name">{{year.name}}</option>
                            </select>
                            <div class="help-block" v-if="form.errors.has('year')">
                                <strong>{{ form.errors.get('year') }}</strong>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-sm-3">
                    <div :class="formGroupClass('type')">
                        <div class="form-group">
                            <select class="form-control" name="type" v-model="form.type">
                                <option :value="0">Typ / Motor</option>
                                <template v-for="fuel in types">
                                    <template v-for="motors in fuel.children">
                                        <option v-for="motor in motors.grandchildren" :value="motor.name">{{motor.name}}</option>
                                    </template>
                                </template>
                            </select>
                            <div class="help-block" v-if="form.errors.has('type')">
                                <strong>{{ form.errors.get('type') }}</strong>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-xs-12">
                    <div :class="formGroupClass('question')">
                        <div class="form-group">
                            <textarea name="question" class="form-control" v-model="form.question" placeholder="Welches Ersatzteil suchen Sie?*"></textarea>
                            <div class="help-block" v-if="form.errors.has('question')">
                                <strong>{{ form.errors.get('question') }}</strong>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-xs-6">
                    <div :class="formGroupClass('email')">
                        <div class="form-group">
                            <input name="email" class="form-control" v-model="form.email" placeholder="Ihre eMail Adresse*">
                            <div class="help-block" v-if="form.errors.has('email')">
                                <strong>{{ form.errors.get('email') }}</strong>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-xs-6">
                    <div :class="formGroupClass('phone')">
                        <div class="form-group">
                            <input name="phone" class="form-control" v-model="form.phone" placeholder="Ihre Telefonnummer*">
                            <div class="help-block" v-if="form.errors.has('phone')">
                                <strong>{{ form.errors.get('phone') }}</strong>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-xs-12">
                    <button class="btn btn-default" type="button" @click="onClick">
                        <i class="fa fa-spinner fa-spin" v-if="loading"></i>
                        <slot>Jetzt unverbindlich anfragen</slot>
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                form: new Form({
                    brand: 0,
                    car: 0,
                    year: 0,
                    type: 0,
                    question: null,
                    email: null,
                    phone: null,
                }),
                brands: [
                    {id:3, name:'Audi'},
                    {id:4, name:'Bmw'},
                    {id:5, name:'Mercedes'},
                    {id:6, name:'Porsche'}
                ],
                cars: [],
                years: [],
                types: [],
                loading: false,
                success: false,
                showForm: true
            }
        },

        methods: {
            formGroupClass(name) {
                return this.form.errors.has(name) ? 'form-group has-error' : 'form-group';
            },
            onChangeBrand(e) {
                let select = e.currentTarget;
                new Form({id: select.options[select.selectedIndex].dataset.id, noSave: true})
                    .post('/api/cars')
                    .then((cars) => {
                        App.event.fire('car.brand.loaded.form', cars);
                    });
            },
            onChangeCar(e) {
                let select = e.currentTarget;
                let car_id = select.options[select.selectedIndex].dataset.id;
                let car = this.cars.filter((item) => {
                    return item.id == car_id;
                }).shift();
                App.event.fire('car.open.years.form', car.children);
            },
            onChangeYear(e) {
                let select = e.currentTarget;
                new Form({id: select.options[select.selectedIndex].dataset.id, noSave: true})
                .post('/api/types')
                .then((types) => {
                    App.event.fire('car.open.types.form', types);
                });
            },
            onClick() {
                this.loading = true;
                this.form.put('/inquiry').then(response => {
                    App.event.fire('inquiry.success', response);
                }).catch(errors => {
                    App.event.fire('inquiry.failed', errors);
                });
            }
        },
        created() {

            App.event.listen('car.brand.loaded.form', (cars) => {
                this.cars = cars;
            });

            App.event.listen('car.open.years.form', (years) => {
                this.years = years;
            });

            App.event.listen('car.open.types.form', (types) => {
                this.types = types;
            });

            App.event.listen('inquiry.failed', () => { this.loading = false; });
            App.event.listen('inquiry.success', response => {
                this.loading = false;
                this.showForm = false;
                this.success = true;
            });
        },
    }
</script>